module.exports = __webpack_public_path__ + "static/media/MIAB9311-180730-41_Small.0850fa57.jpg";